import React from "react";
import img1 from "../assets/img/12.jpg"
const About = () => {
  return (
    <>
      <div className="content_2_hotel_about">
        <div>
          <div className="content_2_about_sides">
            <div className="inner">
              <div className="text">
                <p>
                  Welcome to aufantasy, where cricket meets the excitement of
                  fantasy sports! Take charge, build your dream team, strategize
                  every move, and dominate the leaderboard. Step into a world
                  where every match, run, and wicket brings you closer to
                  victory. Think you have what it takes to outsmart the
                  competition? It’s time to put your cricket knowledge to the
                  test and rise to the top!
                </p>
                <h3>Why fantasy cricket?</h3>
                <p>
                  Fantasy cricket is more than a game—it's an immersive
                  experience that deepens your connection to the sport you love.
                  With aufantasy, you have the freedom to craft your dream team,
                  make real-time decisions, and compete with fellow cricket
                  enthusiasts. Every match becomes a unique journey where your
                  tactical skills and cricket expertise shape the results. In
                  fantasy cricket, every point matters, and every win feels
                  rewarding. Whether you&#39;re a seasoned expert or a newcomer,
                  aufantasy offers you the opportunity to control your cricket
                  destiny.
                </p>
              </div>
            </div>
            <div className="image">
              <img src={img1} alt="Cricket Image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
